import React, { useState, useEffect } from "react";
import Scrollspy from "react-scrollspy";
import Social from "../SocialTwo";
import { NavLink } from "react-router-dom";

const Header = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const [navbar, setNavbar] = useState(false);

  // Replace this with your desired URL/link
  const contactLink = "https://www.facebook.com/share/1DhqyGkbst"; 

  useEffect(() => {
    const changeBackground = () => {
      if (window.scrollY >= 80) {
        setNavbar(true);
      } else {
        setNavbar(false);
      }
    };

    window.addEventListener("scroll", changeBackground);
    return () => window.removeEventListener("scroll", changeBackground);
  }, []);

  return (
    <>
      <div className="shane_tm_topbar">
        <div className={navbar ? "topbar_inner opened" : "topbar_inner"}>
          <div className="menu">
            {/* PC Desktop Menu retains Domů */}
            <Scrollspy
              className="anchor_nav"
              items={["home", "portfolio"]}
              currentClassName="current"
              offset={-200}
            >
              <li>
                <a href="#home">Domů</a>
              </li>
              <li>
                <a href="#portfolio">Naši kandidáti</a>
              </li>
              <li>
                <a
                  href={contactLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Kontakt
                </a>
              </li>
            </Scrollspy>
          </div>
          {/* End menu */}
        </div>
      </div>
      {/* End shane_tm_topbar */}

      {/* Start shane mobile menu */}
      <div className="shane_tm_mobile_menu">
        <div className="topbar_inner">
          <div className="container bigger">
            <div className="topbar_in">
              <div
                className="my_trigger"
                onClick={handleClick}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") handleClick();
                }}
              >
                <div
                  className={
                    click
                      ? "hamburger hamburger--collapse-r is-active"
                      : "hamburger"
                  }
                >
                  <div className="hamburger-box">
                    <div className="hamburger-inner"></div>
                  </div>
                </div>
                {/* End hamburger menu */}
              </div>
            </div>
          </div>
        </div>
        <div className={click ? "dropdown active" : "dropdown"}>
          <div className="container">
            <span
              className="close_menu"
              onClick={handleClick}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") handleClick();
              }}
            >
              close
            </span>
            <div className="dropdown_inner">
              {/* Mobile menu only has Naši kandidáti & Kontakt */}
              <ul className="anchor_nav">
                <li>
                  <a href="#portfolio" onClick={handleClick}>
                    Naši kandidáti
                  </a>
                </li>
                <li>
                  <a
                    href={contactLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleClick}
                  >
                    Kontakt
                  </a>
                </li>
              </ul>
              <div className="social-menu">
                <Social />
              </div>
              {/* End social share */}
            </div>
          </div>
          {/* End container */}
        </div>
      </div>
      {/* End shane mobile menu */}
    </>
  );
};

export default Header;